module.exports = "<div class=\"selector event\">\n  <h5>Select an Event</h5>\n  <div class=\"content\" [cxWait]=\"(events | async)?.length\">\n    <prg-list-selector [listSource]=\"(events | async)\" displayField=\"display\" (selected)=\"eventSelected($event)\"></prg-list-selector>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-event/select-event.html
// module id = 1523
// module chunks = 2